// colour.js.liquid - controls product selectors for collection.colour
jQuery(document).ready(function ($) {
//empty the visible cart
  $('#colorSelector').on('click', 'button', function() {
      // Get the id of the button clicked
      var colorFilter = (this.id);
    // Hide current price
    $( "#visible-cart .active" )
      .addClass('not-active')
      .removeClass('active');// Hide

    $( "#visible-cart div" )
      .filter("[data-color="+ colorFilter +"]")
      .addClass('active')
      .removeClass('not-active');

    // Add and remove active class as needed
    $('#colorSelector button.active').removeClass('active');
    $(this).addClass('active');

    // Hide non matching products
    $(".rotator.active" ).addClass('not-active').removeClass('active');// Hide
    //Show the item that has the color of the button that was clicked.
      $("div#product-selector .rotator" )
      .filter("[data-color="+ colorFilter +"]")
      .addClass('active')
      .removeClass('not-active');// Show
      //empty the visible cart
    });
});

jQuery(document).on('submit', '#AddToCartForm', function(event) {
  event.preventDefault();
});
